import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

export interface PageHeaderAction {
    label: string;
    icon?: string;
    styleClass?: string;
    outlined?: boolean;
    onClick?: () => void;
}

@Component({
    selector: 'app-page-header',
    imports: [CommonModule, ButtonModule],
    template: `
        <section class="flex justify-between items-center mb-6 bg-white rounded-xl shadow-sm border border-gray-100 p-5">
            <div class="flex items-center gap-3">
                @if (icon()) {
                    <div [class]="getIconContainerClasses()">
                        <span class="material-icons-outlined text-white text-lg">{{ icon() }}</span>
                    </div>
                }
                <div>
                    <span class="text-xl font-semibold text-gray-900">{{ title() }}</span>
                    @if (subtitle()) {
                        <p class="text-sm text-gray-500 mt-0.5">{{ subtitle() }}</p>
                    }
                </div>
            </div>
            <div class="flex gap-3">
                <ng-content select="[actions]"></ng-content>
            </div>
        </section>
    `
})
export class PageHeaderComponent {
    icon = input<string>();
    title = input.required<string>();
    subtitle = input<string>('');
    iconGradient = input<string>('from-blue-500 to-blue-600');

    getIconContainerClasses(): string {
        const baseClasses = 'w-10 h-10 rounded-lg bg-gradient-to-br flex items-center justify-center';
        return `${baseClasses} ${this.iconGradient()}`;
    }
}
